<template>
  <div class="mm-table-wrapper w-full max-w-full overflow-x-auto border border-black bg-white">
    <table class="min-w-full divide-y divide-black">
      <thead class="bg-black text-white italic">
        <tr class="divide-x divide-black">
          <th v-if="selectable" scope="col" class="w-10 px-4 py-3 text-center text-[13px] font-black uppercase tracking-wide text-white">
            <div class="flex flex-col items-center gap-1">
              <span class="text-[10px] leading-none mb-1">Selecteer</span>
              <input type="checkbox" :checked="allSelected" @change="$emit('select-all', $event.target.checked)" class="h-4 w-4 rounded border-white text-black focus:ring-white" />
            </div>
          </th>
          <th v-for="(col, idx) in columns" :key="idx" scope="col"
              :class="[
                'px-4 py-3 text-left text-[13px] font-black uppercase tracking-wide text-white select-none',
                col.key === 'actions' ? 'w-24' : '',
                col.key === 'id' ? 'w-32' : '',
                col.key === 'status' ? 'w-32' : '',
                col.key === 'date' ? 'w-32' : '',
              ]">
            <button v-if="col.sortable" type="button" class="inline-flex items-center gap-1 hover:underline text-left uppercase"
                    @click="$emit('sort-change', col.key)">
              <span>{{ col.label }}</span>
              <span v-if="sortKey===col.key" aria-hidden="true">
                <svg v-if="sortDir==='asc'" class="h-3 w-3" viewBox="0 0 24 24"><path fill="currentColor" d="M7 14l5-5 5 5H7z"/></svg>
                <svg v-else class="h-3 w-3" viewBox="0 0 24 24"><path fill="currentColor" d="M7 10l5 5 5-5H7z"/></svg>
              </span>
            </button>
            <span v-else>{{ col.label }}</span>
          </th>
        </tr>
      </thead>
      <tbody class="divide-y divide-black bg-white">
        <slot name="rows">
          <tr v-for="(row, ri) in rows" :key="row.id || ri" class="hover:bg-neutral-50 divide-x divide-black even:bg-[#F9F9F9]">
            <td v-if="selectable" class="px-4 py-3 text-center align-middle">
              <input type="checkbox" :checked="selectedRows.includes(row.id || ri)" @change="$emit('select-row', row.id || ri, $event.target.checked)" class="h-4 w-4 rounded border-black text-black focus:ring-black" />
            </td>
            <td v-for="(col, ci) in columns" :key="ci" class="px-4 py-3 text-[15px] text-neutral-900 align-middle">
              <slot :name="`cell:${col.key}`" :row="row">{{ row[col.key] }}</slot>
            </td>
          </tr>
        </slot>
      </tbody>
    </table>
  </div>
</template>

<script setup>
const props = defineProps({
  columns: { type: Array, default: () => [] },
  rows: { type: Array, default: () => [] },
  sortKey: { type: String, default: '' },
  sortDir: { type: String, default: 'asc' },
  selectable: { type: Boolean, default: false },
  selectedRows: { type: Array, default: () => [] },
  allSelected: { type: Boolean, default: false },
})
defineEmits(['sort-change', 'select-row', 'select-all'])
</script>

<style scoped>
.mm-table-wrapper :deep(tbody button),
.mm-table-wrapper :deep(tbody a[role="button"]),
.mm-table-wrapper :deep(tbody a.inline-flex),
.mm-table-wrapper :deep(tbody a.mm-modal__button),
.mm-table-wrapper :deep(tbody a[href$=".pdf"]) {
  border: 1px solid black !important;
}
</style>
